import { ORG_ROUTES, STORE_ROUTES } from "@/config/router";
import { useParams } from "react-router-dom";
import { useGuardedNavigate } from "@/hooks/use-unsaved-changes-blocker";

export const useOrgNavigate = () => {
    const navigate = useGuardedNavigate();
    const { orgSlug } = useParams();
    if (!orgSlug) {
        throw new Error('Org slug is required');
    }
    const orgRoutes = ORG_ROUTES(orgSlug);
    return {
        orgRoutes,
        navigate,
        orgSlug,
    }
}

export const useStoreNavigate = () => {
    const navigate = useGuardedNavigate();
    const { id, orgSlug } = useParams();
    if (!id) {
        throw new Error('Store ID is required');
    }
    if (!orgSlug) {
        throw new Error('Org slug is required');
    }
    const storeRoutes = STORE_ROUTES(orgSlug, id);
    const orgRoutes = ORG_ROUTES(orgSlug);
    return {
        storeRoutes,
        orgRoutes,
        navigate,
        id,
        orgSlug,
    }
}
